import { ReactElement } from 'react';

const FVSStep3AlertContent4 = (): ReactElement => (
  <div>
    <br />
    <p>You should attach at least one supporting document to your application. This can be either:</p>
    <ul>
      <li>a document prepared by a relevant authority or professional, or</li>
      <li>a statutory declaration by you (if you cannot get a document from an authority or professional)</li>
    </ul>
    <p>
      If you are unable to provide the types of evidence suggested above, please contact the Fines Victoria FVS team to discuss your options via email (
      <a href="mailto:fvs@justice.vic.gov.au">fvs@justice.vic.gov.au</a>
      <span>) or phone (</span>
      <a href="tel:1300019983" title="Fines Victoria FVS phone number">
        1300 019 983
      </a>
      )
    </p>
    <br />
    <p>
      <span>You can read more about the evidence requirements in the </span>
      <a target="_blank" href="https://online.fines.vic.gov.au/-/media/Files/Guide-to-the-Family-Violence-Scheme.pdf" rel="noreferrer">
        Guide to FVS
      </a>
      <span> (opens in new window)</span>
    </p>
  </div>
);

export default FVSStep3AlertContent4;
